"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const styles = (0, _makeStyles.default)(theme => {
  var _theme$palette;
  return {
    cartItem: {
      borderBottom: "1px solid ".concat((_theme$palette = theme.palette) === null || _theme$palette === void 0 || (_theme$palette = _theme$palette.grey) === null || _theme$palette === void 0 ? void 0 : _theme$palette[100]),
      display: "flex",
      paddingBottom: theme.spacing(2),
      paddingTop: theme.spacing(2),
      "&:first-child": {
        paddingTop: 0
      },
      "&.mco-shop-cart-item--is-disabled": {
        "& .mco-shop-cart-item__content": {
          paddingRight: 0
        }
      },
      "& .mco-shop-availability": {
        marginTop: "auto",
        paddingTop: theme.spacing(1)
      }
    },
    image: {
      flex: "0 0 30%",
      marginRight: theme.spacing(2),
      "& img": {
        objectFit: "contain !important"
      }
    },
    fallbackImage: {
      display: "flex",
      minHeight: "100%",
      paddingBottom: "109.375%",
      position: "relative",
      "& .mco-fallback-image": {
        left: 0,
        position: "absolute",
        top: 0
      }
    },
    content: {
      display: "flex",
      flex: 1,
      flexDirection: "column",
      position: "relative"
    },
    title: {
      fontSize: "1rem",
      fontWeight: theme.typography.fontWeightBold
    },
    attributes: {
      fontSize: "0.875rem",
      lineHeight: 1.28,
      marginTop: theme.spacing(1),
      "& span": {
        fontWeight: theme.typography.fontWeightBold
      }
    },
    wrapper: {
      alignItems: "flex-end",
      display: "flex",
      justifyContent: "space-between",
      marginTop: "auto",
      paddingTop: theme.spacing(2)
    },
    quantity: {
      height: 32,
      "& input": {
        fontSize: "1rem"
      }
    },
    quantityLabel: {
      fontSize: "1rem",
      lineHeight: 1.2,
      marginTop: "auto"
    },
    shippingLabel: {
      fontSize: "0.875rem",
      lineHeight: 1.28,
      paddingTop: theme.spacing(1),
      marginTop: "auto"
    },
    price: {
      marginLeft: "auto",
      "& .mco-shop-price__wrapper": {
        alignItems: "flex-end",
        flexDirection: "column"
      },
      "& .mco-shop-price__value": {
        fontSize: "1rem",
        lineHeight: 1.2,
        order: 1
      },
      "& .mco-shop-price__original": {
        fontSize: "0.875rem",
        lineHeight: 1.2
      }
    },
    deleteButton: {
      height: 32,
      position: "absolute",
      right: -4,
      top: -4,
      width: 32
    }
  };
});
var _default = exports.default = styles;